import {
  appsWarehouseApiGetTransfer,
  appsWarehouseApiListTransfers,
  getAppsWarehouseApiGetTransferQueryKey,
  getAppsWarehouseApiListTransfersQueryKey,
} from '@/lib/api/generated/endpoints'
import type { AppsWarehouseApiListTransfersParams } from '@/lib/api/generated/types.ts/appsWarehouseApiListTransfersParams'
import type { TransferOut } from '@/lib/api/generated/types.ts/transferOut'
import { typedSuspenseOptions } from '@/lib/query/typed-suspense-query'

/**
 * Cross-warehouse Transfer list — drives the global «Переміщення» sidebar
 * entry (Task 10 / warehouse-model plan).
 *
 * Backend: `GET /api/transfers?source_warehouse_id=&destination_warehouse_id=&status=&project_id=`.
 */
export const transfersListQuery = (params?: AppsWarehouseApiListTransfersParams) =>
  typedSuspenseOptions<readonly TransferOut[]>({
    queryKey: getAppsWarehouseApiListTransfersQueryKey(params),
    queryFn: ({ signal }) =>
      appsWarehouseApiListTransfers(params, { signal }) as unknown as Promise<
        readonly TransferOut[]
      >,
    staleTime: 15_000,
  })

/** Single Transfer detail (used by detail/edit page). */
export const transferDetailQuery = (transferId: number) =>
  typedSuspenseOptions<TransferOut>({
    queryKey: getAppsWarehouseApiGetTransferQueryKey(transferId),
    queryFn: ({ signal }) =>
      appsWarehouseApiGetTransfer(transferId, { signal }) as unknown as Promise<TransferOut>,
    staleTime: 15_000,
  })
